import {
    el, unmount, mount, setStyle
} from 'redom';
import { projectInterface } from '../Tool/interface';

export interface ILoaderOptions {
    container: HTMLElement;
    barVisible?: boolean;
    barPosition?: 'top' | 'bottom' | 'center';
    numberVisible?: boolean;
    titleVisible?: boolean;
    imageVisible?: boolean;
    color?: number[];
    imageUrl?: string;
    font?: string;
}

projectInterface.loader = {
    barVisible: 'bv',
    barPosition: 'bp',
    titleVisible: 'tv',
    numberVisible: 'nv',
    imageVisible: 'iv',
    imageUrl: 'iu',
    color: 'c',
    font: 'f',
};

export class UiLoadingScreen {
    private title: HTMLElement;

    private container: HTMLElement;

    private shown = true;

    private centeredBlock: HTMLElement;

    private progressbar: HTMLElement;

    private progressbarContainer: HTMLElement;

    private progressNumber: HTMLElement;

    constructor(parent: HTMLElement) {
        this.container = el('div', {
            style: {
                position: 'absolute', top: '0px', left: '0px', width: '100%', height: '100%', 'overflow-y': 'hidden !important', 'overflow-x': 'hidden !important', outline: 'none', 'z-index': 100000, background: 'rgba(0,0,0,0)', transition: 'all ease 200ms'
            }
        });
        this.centeredBlock = el('div', {
            style: {
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', 'z-index': 2
            }
        });
        mount(this.container, this.centeredBlock);

        this.title = el('div', {
            style: {
                position: 'relative', height: 'auto', width: '200%', left: '-50%', 'font-family': 'Arial', 'text-align': 'center', color: 'white', 'text-shadow': '#000 0px 0 10px'
            }
        });

        setStyle(this.container, { display: 'none' });
        mount(parent, this.container);

        this.progressNumber = el('div', {
            style: {
                position: 'relative', width: '100%', 'margin-top': '15px', 'font-family': 'Arial', 'text-align': 'center', color: 'white', 'text-shadow': '#000 0px 0 10px'
            }
        });
        this.progressbarContainer = el('div', {
            style: {
                position: 'relative', background: 'rgba(0, 0, 0, 0.6)', width: '200px', 'margin-top': '15px', left: '50%', transform: 'translateX(-50%)', 'border-radius': '5px', 'z-index': 3
            }
        });
        this.progressbar = el('div', {
            style: {
                position: 'relative', background: '#CCCCCC', width: '0%', height: '100%', 'border-radius': '5px'
            }
        });
        mount(this.progressbarContainer, this.progressbar);
        this.setSize(1);
        this.setBarPosition('center');
        this.setProgress(0);
    }

    public setProgress(progress: number): void {
        this.animateBar(0.2 + (4 * progress) / 5, 20);
    }

    public checkOptions(lOptions: ILoaderOptions): void {
        if (lOptions.color !== undefined) this.setColor(lOptions.color);
        if (lOptions.font !== undefined) this.setFont(lOptions.font);
        //! Removed for now as image is not great
        // if (lOptions.imageUrl !== undefined) this.setImage(lOptions.imageUrl);
        // if (lOptions.imageVisible !== undefined) this.setImageVisible(lOptions.imageVisible);
        if (lOptions.titleVisible !== undefined) this.setTitleVisible(lOptions.titleVisible);
        if (lOptions.numberVisible !== undefined) this.setNumberVisible(lOptions.numberVisible);
        if (lOptions.barPosition !== undefined) this.setBarPosition(lOptions.barPosition);
        if (lOptions.barVisible !== undefined) this.setBarVisible(lOptions.barVisible);
    }

    public setNumberVisible(numberVisible: boolean): void {
        if (numberVisible) mount(this.centeredBlock, this.progressNumber);
        else unmount(this.centeredBlock, this.progressNumber);
    }

    public setColor(color: number[]): void {
        if (!color) return; // Security in case no color saved
        setStyle(this.title, { color: `rgb(${color[0]},${color[1]},${color[2]})` });
        setStyle(this.progressNumber, { color: `rgb(${color[0]},${color[1]},${color[2]})` });
        // setStyle(this.progressbar, {
        //     background: 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')',
        //     'box-shadow': '0px 0px 10px rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')'
        // });
        setStyle(this.progressbar, { background: `rgb(${color[0]},${color[1]},${color[2]}, 0.7)` });
    }

    public setFont(font: string): void {
        setStyle(this.title, { 'font-family': font });
        setStyle(this.progressNumber, { 'font-family': font });
    }

    private currentBarPosition: 'top' | 'bottom' | 'center' = 'center';

    public setBarPosition(pos: 'top' | 'bottom' | 'center'): void {
        this.currentBarPosition = pos;
        if (pos === 'top') {
            setStyle(this.progressbarContainer, {
                top: '0px', position: 'absolute', width: '100%', left: '0%', transform: 'translateX(0%)'
            });
            mount(this.container, this.progressbarContainer);
        } else if (pos === 'bottom') {
            setStyle(this.progressbarContainer, {
                bottom: '0px', position: 'absolute', width: '100%', left: '0%', transform: 'translateX(0%)'
            });
            mount(this.container, this.progressbarContainer);
        } else {
            setStyle(this.progressbarContainer, {
                position: 'relative', width: '200px', 'margin-top': '15px', left: '50%', transform: 'translateX(-50%)'
            });
            mount(this.centeredBlock, this.progressbarContainer);
        }
    }

    public setBarVisible(visible: boolean): void {
        if (visible) {
            setStyle(this.progressbarContainer, { display: 'block' });
            this.setBarPosition(this.currentBarPosition);
        } else {
            setStyle(this.progressbarContainer, { display: 'none' });
        }
    }

    private setSize(ratio: number) {
        setStyle(this.progressNumber, { 'font-size': `${(ratio * 30).toString()}px` });
        setStyle(this.title, { 'font-size': `${(ratio * 20).toString()}px` });
        setStyle(this.progressbarContainer, { height: `${(ratio * 8).toString()}px` });
    }

    private currentbarvalue = 0;

    private interval;

    public animateBar(howmuch: number, animLength: number, callback?: () => void): void {
        if (this.interval) clearInterval(this.interval);
        howmuch = Math.min(1, howmuch);
        howmuch = Math.max(0, howmuch);
        const change = (howmuch) - this.currentbarvalue;
        let i = 0;
        // Need to use interval as engine is not yet started
        this.interval = setInterval(() => {
            this.currentbarvalue += change / animLength;
            const progress = Math.min(0.1 + this.currentbarvalue * 0.9, 1);
            this.setLoadProgress(progress);
            if (i === animLength) {
                clearInterval(this.interval);
                if (callback) callback();
            }
            i++;
        }, 20);
    }

    private setLoadProgress(progress: number) {
        const width = `${Math.round(progress * 100).toString()}%`;
        setStyle(this.progressbar, { width });
        this.progressNumber.textContent = width;
    }

    public success(callback?: () => void): void {
        this.animateBar(1, 5, () => {
            this.hide();
            if (callback) callback();
        });
    }

    private image: HTMLElement;

    private setImage(imageUrl: string) {
        if (this.image) unmount(this.container, this.image);
        this.image = el('div', {
            style: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                'overflow-y': 'hidden !important',
                'overflow-x': 'hidden !important',
                outline: 'none',
                'z-index': 1,
                'background-image': `url(${imageUrl})`,
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat',
            },
        });
        mount(this.container, this.image);
    }

    private setImageVisible(visible: boolean) {
        if (!this.image) return;
        if (visible) mount(this.container, this.image);
        else unmount(this.container, this.image);
    }

    public setTitleVisible(titleVisible: boolean): void {
        if (titleVisible) mount(this.centeredBlock, this.title);
        else unmount(this.centeredBlock, this.title);
    }

    public show(text?: string): void {
        this.currentbarvalue = 0;
        this.setLoadProgress(this.currentbarvalue);
        this.shown = true;
        setStyle(this.container, { display: 'block', opacity: 1 });
        if (text) this.title.textContent = text;
        this.progressNumber.textContent = '0%';
    }

    public hide(): void {
        if (this.shown) {
            this.hideContainer();
        }
    }

    private hideContainer() {
        // Do not do display: 'none'  to have the animation
        setStyle(this.container, { opacity: 0, 'pointer-events': 'none' });
    }
}
